module.exports = __webpack_public_path__ + "img/s9.31ad09a1.svg";